import { render } from "./Profilo.vue?vue&type=template&id=67a03afd&scoped=true&ts=true"
import script from "./Profilo.vue?vue&type=script&lang=ts"
export * from "./Profilo.vue?vue&type=script&lang=ts"

import "./Profilo.vue?vue&type=style&index=0&id=67a03afd&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_v2/app_entasys/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67a03afd"]])

export default __exports__